export default __webpack_public_path__ + "9e32fc4ac8c91898af4ce309f479d11e.png";